import {
//   getUserGroupTree, listSkillGroup, listRoles
} from '@/api/user'
import globalVaribale from '@/utils/globalVariable'
const defaultSgGroupId = globalVaribale.defaultSkillGroupId
const getDefaultSkillState = () => {
  return {
    defaultSkillGroupId: defaultSgGroupId // TODO 默认选择技能组
  }
}

const role = {
  namespaced: true, // true表示声明为【带命名空间】的模块,这样该模块下的state,mutations等属性中定义的变量属于【子命名空间】下的局部变量,不会与其他【子命名空间】下的变量冲突;不写namespaced:true,则本模块下的state属于【根命名空间】下的全局变量
  state: {
    defaultSkillGroupId: defaultSgGroupId // TODO 默认选择技能组
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultSkillState())
    }
  },
  actions: {
  },
  modules: {
  }
}

export default role
